import { forwardRef } from "react";
import type { ChatDateDividerProps } from "../types";
import { cn } from "@semo/shared-ui";

/**
 * ChatDateDivider - 채팅 메시지 날짜 구분선
 *
 * 메시지 목록에서 날짜별 구분을 표시합니다.
 */
export const ChatDateDivider = forwardRef<HTMLDivElement, ChatDateDividerProps>(
  ({ date }, ref) => {
    return (
      <div
        ref={ref}
        data-slot="chat-date-divider"
        className={cn("flex items-center justify-center py-4 sm:py-6")}
      >
        <div className="flex items-center gap-3 sm:gap-4 w-full max-w-sm">
          <div className="flex-1 h-px bg-slate-200 " />
          <span className="text-2xs sm:text-xs font-medium text-slate-500  whitespace-nowrap px-2">
            {date}
          </span>
          <div className="flex-1 h-px bg-slate-200 " />
        </div>
      </div>
    );
  },
);

ChatDateDivider.displayName = "ChatDateDivider";
